


















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Checklist from '../Checklist.vue'
import VueUploadComponent from 'vue-upload-component'
import auth from '@/auth'
import { FileStatus } from '@/api'

@Component({ components: { Checklist, VueUploadComponent } })
export default class ToCheck extends Vue {
  @Prop(String) id!: string

  $refs!: {
    upload: VueUploadComponent;
  }

  public files: Array<VUFile> = []
  public blocked = false

  public inputFile (newFile: VUFile, oldFile: VUFile) {
    if (Boolean(newFile) !== Boolean(oldFile)) {
      this.$refs.upload.active = true
    }
  }

  public removeFile (file: VUFile) {
    this.$refs.upload.remove(file)
  }

  public uploadChunk (): object {
    const headers = {
      Token: auth.userToken()
    }

    const res = {
      action: 'https://prepodam.ru/api/v2/file',
      minSize: 1,
      maxActive: 3,
      maxRetries: 5,
      headers: headers
    }

    return res
  }

  private getID (val: string): bigint {
    const id = Number.parseInt(val, 10)
    if (Number.isNaN(id)) {
      return BigInt(1)
    }

    return BigInt(id)
  }

  public toCheck () {
    const files: bigint[] = []

    this.files.forEach((_value: VUFile, index: number) => {
      const resp = this.$refs.upload.files[index.valueOf()].response as FileStatus
      files.push(BigInt(resp.id))
    })

    this.blocked = true

    auth.userClient().OrderToCheck({ id: this.getID(this.id), fileIds: files }).then(() => {
      this.$router.push('/controlPanel.html')
    }).finally(() => {
      this.blocked = false
    })
  }
}
